'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HelpLink = require('./components/HelpLink.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HelpLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-help-link/lib/index.js
// module id = 1486
// module chunks = 1